const mEditionBillingAcademyProducts = {
  mEditionBillingAcademyProducts: {
    alerts: {
      readAcademy: {
        error: 'La academia que busca con ese url no existe'
      }
    },

    tooltip: {
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingAcademyProducts
